import script from "./EmpNoticeDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmpNoticeDetail.vue?vue&type=script&setup=true&lang=ts"

import "./EmpNoticeDetail.vue?vue&type=style&index=0&id=316d9642&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316d9642"]])

export default __exports__